import { useEffect, useRef } from "react";
import { useCharles } from "@/contexts/CharlesContext";
import { cn } from "@/lib/utils";

export function ConciergeChat({ advisorName }: { advisorName?: string | null }) {
  const { transcript, started } = useCharles();
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [transcript.length]);

  const name = advisorName?.trim() || "your advisor";

  return (
    <section className="concierge-card p-5 space-y-3">
      <div className="flex items-baseline justify-between">
        <p className="concierge-eyebrow">Conversation</p>
        {transcript.length > 0 && (
          <span className="text-xs text-muted-foreground tabular-nums">
            {transcript.length} {transcript.length === 1 ? "turn" : "turns"}
          </span>
        )}
      </div>

      <div
        ref={scrollRef}
        className="max-h-[45vh] overflow-y-auto pr-1 space-y-3"
      >
        {transcript.length === 0 ? (
          <p className="text-sm text-muted-foreground py-6 text-center">
            {started
              ? `Your words and ${name}'s replies will appear here as you speak.`
              : "Your conversation will appear here once you begin."}
          </p>
        ) : (
          transcript.map((t) => (
            <div
              key={t.id}
              className={cn(
                "flex",
                t.role === "user" ? "justify-end" : "justify-start",
              )}
            >
              {t.role === "user" ? (
                <div className="max-w-[80%] rounded-2xl bg-secondary text-secondary-foreground px-4 py-2 text-sm leading-relaxed">
                  {t.text}
                </div>
              ) : (
                <div className="max-w-[85%] text-sm leading-relaxed text-foreground/90">
                  {t.text}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </section>
  );
}

export default ConciergeChat;
